<template>
  <section class="sponsors">
    <div class="sponsors__content">
      <hr class="full-line" />
      <h1 class="sponsors__title">
          Title Sponsors
      </h1>
      <div class="sponsors__logos title-sponsors">
        <a
          v-for="sponsor in titleSponsors"
          :key="sponsor.name"
          :href="sponsor.url"
          target="_blank"
        >
          <div class="sponsors__item single" :class="{ 'sponsors__item--bigger': sponsor.biggerSponsor }">
            <div
              class="sponsors__logo-container"
              :class="sponsor.specialClass"
            >
              <img :src="getImageUrl(sponsor.logo)" :alt="sponsor.name" :class="sponsor.imgClass" />
            </div>
          </div>
        </a>
      </div>
      <div class="sponsors__logos big-sponsors">
        <a
          v-for="sponsor in bigSponsors"
          :key="sponsor.name"
          :href="sponsor.url"
          target="_blank"
        >
          <div class="sponsors__item single" :class="{ 'sponsors__item--bigger': sponsor.biggerSponsor }">
            <div
              class="sponsors__logo-container"
              :class="sponsor.specialClass"
            >
              <img :src="getImageUrl(sponsor.logo)" :alt="sponsor.name" :class="sponsor.imgClass" />
            </div>
          </div>
        </a>
      </div>
      <h1 class="sponsors__title reg">
        Sponsors
      </h1>
      <div class="sponsors__logos regular-sponsors">
        <a
          v-for="sponsor in sponsors"
          :key="sponsor.name"
          :href="sponsor.url"
          target="_blank"
        >
          <div class="sponsors__item single" :class="{ 'sponsors__item--bigger': sponsor.biggerSponsor }">
            <div
              class="sponsors__logo-container"
              :class="sponsor.specialClass"
            >
              <img :src="getImageUrl(sponsor.logo)" :alt="sponsor.name" :class="sponsor.imgClass" />
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import sponsors from './json/sponsors.json';

export default {
  name: 'Sponsors',
  data() {
    return {
      titleSponsors: sponsors.titleSponsors,
      bigSponsors: sponsors.bigSponsors,
      sponsors: sponsors.sponsors,
    };
  },
  methods: {
    getImageUrl(imageName) {
      return require(`../assets/sponsors/${imageName}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/components/sponsors.scss';
</style>